// Open synchronously from the click handler so popup blockers allow the tab.
// The authenticated API response is embedded as a local Blob, never as a public URL.
export function openPdfPreview(filename) {
  const tab = window.open('about:blank', '_blank');
  if (!tab) throw new Error('Die PDF-Vorschau wurde blockiert. Bitte neue Tabs für diese Seite erlauben.');
  tab.opener = null;
  const doc = tab.document;
  doc.title = filename;
  doc.documentElement.lang = 'de';
  doc.body.style.margin = '0';
  doc.body.style.fontFamily = 'sans-serif';
  doc.body.textContent = 'PDF wird geladen …';
  return {
    close: () => { if (!tab.closed) tab.close(); },
    show: blob => {
      if (tab.closed) return;
      const url = URL.createObjectURL(blob);
      tab.addEventListener('pagehide', () => URL.revokeObjectURL(url), { once: true });
      const toolbar = doc.createElement('div');
      toolbar.style.cssText = 'box-sizing:border-box;height:44px;padding:12px;background:#e6efe7';
      const download = doc.createElement('a');
      download.href = url; download.download = filename; download.textContent = 'PDF herunterladen';
      toolbar.append(download);
      const frame = doc.createElement('iframe');
      frame.title = 'PDF-Vorschau'; frame.src = url;
      frame.style.cssText = 'display:block;width:100%;height:calc(100vh - 44px);border:0';
      doc.body.replaceChildren(toolbar, frame);
    },
  };
}
